import { CreditCardProductCategory } from '@appTypes/EligibilityApi.interface'

import balanceTransferOfferDurationContent from '@components/CreditCardContent/components/balanceTransferOfferDurationContent'
import guaranteedAprContent from '@components/CreditCardContent/components/guaranteedAprContent'
import minimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/minimumGuaranteedCreditLimitContent'
import noMinimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/noMinimumGuaranteedCreditLimitContent'
import representativeAprContent from '@components/CreditCardContent/components/representativeAprContent'
import transferFeeContent from '@components/CreditCardContent/components/transferFeeContent'

import { ContentProps } from './Content.interface'

const getBalanceTransferContent = ({ creditCard }: ContentProps) => {
    return [
        guaranteedAprContent({ creditCard }),
        minimumGuaranteedCreditLimitContent({
            creditCard,
            category: CreditCardProductCategory.BalanceTransfer,
        }),
        representativeAprContent({ creditCard }),
        balanceTransferOfferDurationContent({ creditCard }),
        noMinimumGuaranteedCreditLimitContent({
            creditCard,
        }),
        transferFeeContent({ creditCard }),
    ]
}

export default getBalanceTransferContent
